export default __webpack_public_path__ + "static/media/monitor.1d81382d.svg";